var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"content-home"},[_c('BannerVideoSection'),_c('div',{staticClass:"content-sections-home"},[_c('BrandSection')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }